<template>
  <div></div>
</template>

<script>
export default {
  name: "SResource",
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/home/search/SResource.vue